import React, { useState, useEffect, useCallback } from 'react';
import { Routes, Route, useNavigate, useParams } from 'react-router-dom';
import axios from 'axios';
import Sidebar from './components/Sidebar';
import MenuViewer from './components/MenuViewer';
import UploadModal from './components/UploadModal';
import EmptyState from './components/EmptyState';
import styles from './App.module.css';

const API = '/api/menus';

export default function App() {
  const [menus, setMenus] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showUpload, setShowUpload] = useState(false);
  const [sidebarCollapsed, setSidebarCollapsed] = useState(true);
  const navigate = useNavigate();

  const fetchMenus = useCallback(async () => {
    try {
      const { data } = await axios.get(API);
      setMenus(data);
    } catch (err) {
      console.error('Errore nel caricamento dei menu', err);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchMenus();
  }, [fetchMenus]);

  const handleUploadSuccess = (newMenu) => {
    setMenus(prev => {
      const filtered = prev.filter(m => m.weekStart !== newMenu.weekStart);
      return [newMenu, ...filtered].sort((a, b) => b.weekStart.localeCompare(a.weekStart));
    });
    setShowUpload(false);
    navigate(`/menu/${newMenu.id}`);
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Eliminare questo menu?')) return;
    await axios.delete(`${API}/${id}`);
    setMenus(prev => prev.filter(m => m.id !== id));
    navigate('/');
  };

  return (
    <div className={styles.layout}>
      <Sidebar menus={menus} loading={loading} onUploadClick={() => setShowUpload(true)} collapsed={sidebarCollapsed} onToggle={() => setSidebarCollapsed(v => !v)} />
      <main className={styles.main}>
        <Routes>
          <Route path="/" element={<EmptyState onUploadClick={() => setShowUpload(true)} hasMenus={menus.length > 0} menus={menus} />} />
          <Route path="/menu/:id" element={<MenuViewerWrapper menus={menus} onDelete={handleDelete} />} />
        </Routes>
      </main>
      {showUpload && (
        <UploadModal onClose={() => setShowUpload(false)} onSuccess={handleUploadSuccess} existingMenus={menus} />
      )}
    </div>
  );
}

function MenuViewerWrapper({ menus, onDelete }) {
  const { id } = useParams();
  const menu = menus.find(m => m.id === id);
  if (!menu) return <div style={{ padding: 32, color: 'var(--text-muted)' }}>Menu non trovato.</div>;
  return <MenuViewer menu={menu} onDelete={onDelete} />;
}
